<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'personal-myBizContactForm',
  components: {
    PageTable,
  },
}
</script>
